import { Field, Input, Label } from '@headlessui/react';
import { ExclamationCircleIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';

export default function BDInputField({
  id,
  type,
  label,
  errorMessage,
  className,
  ...rest
}: {
  id: string;
  type: string;
  label: string;
  errorMessage: string;
  className?: string;
  [key: string]: any;
}) {
  return (
    <Field key={id} className={clsx('relative my-4', className)}>
      <Input
        id={id}
        name={id}
        type={type}
        aria-invalid="true"
        aria-describedby={`${id}-error`}
        className="focus:outline-hidden peer block w-full border-transparent bg-white/10 px-0 py-1 text-slate-600 caret-slate-800 placeholder:text-transparent focus:border-transparent focus:shadow-none focus:ring-0"
        placeholder="placeholder" // Fake because it is transparent
        {...rest}
      />
      <Label
        htmlFor={id}
        className="pointer-events-none absolute -top-3.5 left-0 select-none text-xs font-light text-slate-800 transition-all peer-placeholder-shown:top-2 peer-placeholder-shown:text-sm peer-placeholder-shown:text-slate-500 peer-focus:-top-3.5 peer-focus:text-xs peer-focus:text-slate-800"
      >
        {label}
      </Label>
      <div className="pointer-events-none absolute right-0 top-1.5 hidden items-center pr-3 peer-[&:not(:placeholder-shown):not(:focus):invalid]:flex">
        <ExclamationCircleIcon aria-hidden="true" className="h-5 w-5 text-red-500" />
      </div>
      <div className="bg-bd-dark mb-[1px] h-px w-full peer-focus:mb-0 peer-focus:h-[2px]"></div>
      <p
        id={`${id}-error`}
        className="text-xxs absolute top-full hidden text-red-500 peer-[&:not(:placeholder-shown):not(:focus):invalid]:block"
      >
        {errorMessage}
      </p>
    </Field>
  );
}
